<template>
  <div class="messages d-flex flex-column" v-chat-scroll>
    <message v-for="message in messages"
             :message="message"
             :key="message.id">
    </message>
  </div>
</template>

<script>
import Message from './Message.vue'

import VueChatScroll from 'vue-chat-scroll'
import { mapGetters } from 'vuex'
import Vue from 'vue'

Vue.use(VueChatScroll)

export default {
  name: 'MessageList',

  components: {
    Message
  },

  computed: {
    ...mapGetters([
      'messages'
    ])
  }
}
</script>

<style lang="scss" scoped>
.messages {
  height: 100%;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageList.vue